import React from 'react';
import { useTranslation } from 'react-i18next';
import { container } from 'assets/soter-flex-styles';
import { inner, notice } from './styles';
const SoterTaskProcessingEndBanner = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: notice, role: "status" },
        React.createElement("div", { className: container },
            React.createElement("div", { className: inner },
                React.createElement("p", null, t('SOTER_TASK.PROCESSING_END_BANNER'))))));
};
export default SoterTaskProcessingEndBanner;
